











import { Component, Vue } from 'vue-property-decorator';
import SidePanel from './components/side-panel.vue';
import { formatAnalysisContext, formatZone } from './services/request.formatter';

@Component({
  components: {
    SidePanel,
  },
})
export default class App extends Vue {
  zone: any = null;
  catalog: any = null;
  context: any = null;

  get panelKey() {
    return JSON.stringify({
      zone: this.zone,
      catalog: this.catalog,
      context: this.context,
    });
  }

  created() {
    window.addEventListener('message', (msg: MessageEvent) => {
      if (msg.data.zone) {
        this.zone = formatZone(msg.data.zone);
        this.openPanel();
      }

      if (msg.data.catalog) {
        this.catalog = msg.data.catalog;
        this.openPanel();
      }

      if (msg.data.context) {
        this.context = formatAnalysisContext(msg.data.context);
        this.openPanel();
      }
    });
  }

  openPanel() {
    if (window.parent !== window) {
      window.parent.postMessage({ sidePanel: { open: true } }, '*');
    }
  }

  closePanel() {
    this.zone = null;
    if (window.parent !== window) {
      window.parent.postMessage({ sidePanel: { open: false } }, '*');
    } else {
      window.console.error('Parent window not found');
    }
  }
}
